import * as React from "react";
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { CheckIcon } from "lucide-react";

import { cn } from "@/src/js/lib/utils";

function Checkbox({ className, ...props }: React.ComponentProps<typeof CheckboxPrimitive.Root>) {
  return (
    <CheckboxPrimitive.Root
      data-slot="checkbox"
      className={cn(
        "tw:peer tw:appearance-none tw:p-0 tw:border-neutral-200tw:dark:bg-neutral-200/30 tw:data-[state=checked]:bg-neutral-900 tw:data-[state=checked]:text-neutral-50 tw:data-[state=checked]:border-neutral-900 tw:focus-visible:border-neutral-950 tw:focus-visible:ring-neutral-950/50 tw:aria-invalid:ring-red-500/20 tw:dark:aria-invalid:ring-red-500/40 tw:aria-invalid:border-red-500 tw:size-4 tw:shrink-0 tw:rounded-[4px] tw:border tw:shadow-xs tw:transition-shadow tw:outline-none tw:focus-visible:ring-[3px] tw:disabled:cursor-not-allowed tw:disabled:opacity-50 tw:dark:border-neutral-800 tw:dark:data-[state=checked]:bg-neutral-50 tw:dark:data-[state=checked]:text-neutral-900 tw:dark:data-[state=checked]:border-neutral-50 tw:dark:focus-visible:border-neutral-300 tw:dark:focus-visible:ring-neutral-300/50",
        className,
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        data-slot="checkbox-indicator"
        className="tw:flex tw:items-center tw:justify-center tw:text-current tw:transition-none"
      >
        <CheckIcon className="tw:size-3.5" />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  );
}

export { Checkbox };
